import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.search.js";
import React from 'react';
import PropTypes from 'prop-types';
import qs from 'querystring';
import uri from 'url'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import isPlainObject from 'lodash.isplainobject';

var wrapWithClickProps = function wrapWithClickProps(defaultComponent) {
  var Click = /*#__PURE__*/function (_React$Component) {
    _inherits(Click, _React$Component);

    var _super = _createSuper(Click);

    function Click(props) {
      var _this;

      _classCallCheck(this, Click);

      _this = _super.call(this, props);
      _this.state = {
        header_pageViewId: null
      };
      return _this;
    }

    _createClass(Click, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // Only let clients that execute JS see pageviewid
        this.setState({
          header_pageViewId: this.getPageViewId()
        });
      }
    }, {
      key: "getPageViewId",
      value: function getPageViewId() {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        if (this.props.pageViewId) {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          return this.props.pageViewId;
        }

        if (typeof window !== 'undefined' && window.nwa != null) {
          return window.nwa.getGlobalProp('pageViewId');
        }

        return null;
      }
    }, {
      key: "constructURL",
      value: function constructURL() {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        var parsedUrl = uri.parse(this.props.href);
        var existingProps = qs.parse(parsedUrl.query);

        var props = _objectSpread(_objectSpread(_objectSpread({}, existingProps), this.props.eventProps), {}, {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          header_pageViewId: this.state.header_pageViewId
        });

        var keys = Object.keys(props);

        if (keys.length) {
          // Support nested props to 1 level deep
          keys.forEach(function (key) {
            if (isPlainObject(props[key])) {
              var subKeys = Object.keys(props[key]);
              subKeys.forEach(function (subKey) {
                props["".concat(key, "_").concat(subKey)] = props[key][subKey];
              });
              delete props[key];
            }
          }); // Support legacy `pos` prop as a duplicate of productPosition

          if (props.pos == null && props.clickHeader_productPosition) {
            props.pos = props.clickHeader_productPosition;
          }

          delete parsedUrl.search; // Delete `search` so `format` uses `query` instead

          parsedUrl.query = props;
          return uri.format(parsedUrl);
        } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


        return this.props.href;
      }
    }, {
      key: "render",
      value: function render() {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        var Component = this.props.component || defaultComponent;

        var props = _objectSpread(_objectSpread({}, this.props), {}, {
          href: this.constructURL(),
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          target: this.props.newWindow ? '_blank' : null
        });

        delete props.eventProps;
        delete props.newWindow;
        delete props.pageViewId;
        delete props.component;
        delete props.dispatch;
        return /*#__PURE__*/React.createElement(Component, props);
      }
    }]);

    return Click;
  }(React.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  Click.defaultProps = {
    newWindow: true
  }; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

  Click.propTypes = {
    href: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
    eventProps: PropTypes.object,
    newWindow: PropTypes.bool,
    // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
    pageViewId: PropTypes.string,

    /**
     * Use a custom component instead of the default 'a' html component.
     */
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
    component: PropTypes.any
  };
  return Click;
};

export default wrapWithClickProps('a');
export { wrapWithClickProps };